export const services = [
  {
    title: 'Brows & Lashes',
    desc: 'Threading, shaping, tinting, and lash services tailored to your face and style.',
    tag: 'Most loved',
  },
  {
    title: 'Hair Color & Gloss',
    desc: 'Soft lived-in color, highlights, and glossing for healthy shine and dimension.',
    tag: 'Signature',
  },
  {
    title: 'Cuts & Styling',
    desc: 'Precision cuts, blowouts, and event-ready styling for everyday confidence.',
    tag: 'Any occasion',
  },
];

export const highlights = [
  'Women-focused salon experience in Harrisburg',
  'Clean, calm space with detail-focused artists',
  'Easy booking and clear service recommendations',
];

export const testimonials = [
  {
    quote:
      'They understood exactly what I wanted and made me feel comfortable from the minute I walked in.',
    name: 'Priya',
  },
  {
    quote: 'My brows finally look balanced and natural. The space is beautiful, calm, and spotless.',
    name: 'Ashley',
  },
];